import React, {useState, useRef} from "react";
import classnames from "classnames";
import IconButton from "@material-ui/core/IconButton";
import {Menus} from "../Menus";
import {Cart} from "../Cart";
import {Search} from "../Search";
import {HeaderWrapper} from "../HeaderWrapper";
import {useOnClickOutside} from "../../../../utils/use-on-click-outside";

import styles from "./header.module.scss";
import logo from "../../../../assets/images/logo.svg";
import MenuIcon from "../../../../icons/MenuIcon";
import SearchIcon from "../../../common/Icons/SearchIcon";
import CloseIcon from "../../../common/Icons/CloseIcon";

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchMode, setSearchMode] = useState(false);
  const containerRef = useRef(null);

  useOnClickOutside(containerRef, () => setIsMenuOpen(false));

  return (
    <HeaderWrapper className={searchMode && styles.searchMode}>
      <div className={classnames(styles.container, styles.headerContainer)}>
        <div className={styles.left}>
          <button
            className={classnames(styles.menuButton, {
              [styles.active]: isMenuOpen
            })}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <MenuIcon />
          </button>
          <a href="/" className={styles.logo}>
            <img src={logo} alt="Printio" />
          </a>
          <Menus
            searchMode={searchMode}
            isOpen={isMenuOpen}
            close={() => setIsMenuOpen(false)}
          />
          {searchMode && <Search />}
        </div>
        <div className={styles.right}>
          {!searchMode ? (
            <IconButton
              onClick={() => setSearchMode(true)}
              className={styles.searchButton}
              size="small"
            >
              <SearchIcon />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => setSearchMode(false)}
              className={styles.closeSearchButton}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          )}
          <Cart className={styles.cart} />
        </div>
      </div>
    </HeaderWrapper>
  );
}
